import React, { useEffect, useState } from "react";
import { Tooltip, FormFeedback } from "reactstrap";

const SingleCheckbox = ({
    label = "I agree to the terms and conditions",
    required = false,
    layout = "left",
    name = "singleCheckbox",
    id = "singleCheckbox",
    checked = false,
    onChange = () => { },
    showHelp = false,
    helpText = "Please check it.",
    requiredErrorMessage = "You must agree to the terms and conditions to proceed.",
    customError = null,
    size = "medium",
    color = "#5962ef",
    validateTrigger = false,
}) => {
    const [errors, setErrors] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const handleChange = (event) => {
        const { checked } = event.target;
        setErrors(false);
        onChange(checked);
    };

    useEffect(() => {
        if (validateTrigger && required && !checked) {
            setErrors(true);
        } else {
            setErrors(false);
        }
    }, [validateTrigger, required, checked]);

    return (
        <>
            <div className="d-flex align-items-center">
                <label htmlFor={id} className="d-flex mb-0" style={{ alignItems: "center", cursor: "pointer" }}>
                    <input
                        type="checkbox"
                        id={id}
                        name={name}
                        checked={checked}
                        onChange={handleChange}
                        style={{
                            position: "absolute",
                            opacity: 0,
                            cursor: "pointer",
                        }}
                    />
                    <span
                        style={{
                            display: "inline-block",
                            width: size === "small" ? "16px" : size === "large" ? "24px" : "20px",
                            height: size === "small" ? "16px" : size === "large" ? "24px" : "20px",
                            backgroundColor: checked ? color : "#fff",
                            border: `2px solid ${color}`,
                            borderRadius: "4px",
                            position: "relative",
                            marginRight: layout === "left" ? "10px" : "0",
                            marginLeft: layout === "right" ? "10px" : "0",
                            transition: "background-color 0.2s ease",
                        }}
                    >
                        {checked && (
                            <span
                                style={{
                                    content: "''",
                                    position: "absolute",
                                    top: "2px",
                                    left: "5px",
                                    width: "6px",
                                    height: "12px",
                                    border: "solid white",
                                    borderWidth: "0 2px 2px 0",
                                    transform: "rotate(45deg)",
                                }}
                            />
                        )}
                    </span>
                    <span className="ml-2">
                        {label}
                        {required && <span className="text-danger">*</span>}
                    </span>
                    {showHelp && (
                        <span id={`${id}-help`} className="px-2">
                            <i className="ri-question-line" style={{ cursor: "pointer", fontSize: "16px" }} />
                        </span>
                    )}
                </label>
                {showHelp && (
                    <Tooltip
                        placement="right"
                        isOpen={tooltipOpen}
                        target={`${id}-help`}
                        toggle={() => setTooltipOpen(!tooltipOpen)}
                    >
                        {helpText}
                    </Tooltip>
                )}
            </div>
            {errors && (
                <FormFeedback className="d-block" type="invalid">
                    {customError || requiredErrorMessage}
                </FormFeedback>
            )}
        </>
    );
};

export default SingleCheckbox;
